import React, {Component} from "react"

export default class FormSection extends Component {
  onValueChange(name, value) {
    if (this.props.onValueChange) {
      this.props.onValueChange(name, value)
    }
  }
  render() {
    // Attach onChange to children
    let children = this.props.children
    if (this.props.onValueChange) {
      let _this = this
      children = React.Children.map(this.props.children, function(
        child,
        index
      ) {
        return React.cloneElement(child, {
          onValueChange: _this.onValueChange.bind(_this),
          getDefaultValue: _this.props.getDefaultValue,
          getError: _this.props.getError
        })
      })
    }

    return (
      <div className="sh-form-section">
        {this.props.label && <div className="title">{this.props.label}</div>}
        <div className="children">{children}</div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/forms/FormSection.js